import { useGetProgressQuery } from "../progressSlice";

const useProgressPage = () => {
  const progress = useGetProgressQuery();
  return { progress: progress?.data || [] };
};

export default useProgressPage;
